export const TermsAndConditionsContentALM = () => {
    return (
        <div>
            <h3 className="mt-2">Terms and Conditions</h3>

            <p>These Terms and Conditions (“Terms”) govern your use of the ALM Trading software, website, and related services (collectively, the “Platform”).
                By accessing or using the Platform, you agree to be bound by these Terms. If you do not agree, you may not use the Platform.
                These Terms are between you ("User") and InvestCEO ("Licensor").
            </p>

            <h4>1. Relationship with InvestCEO</h4>
            <p>If you are accessing the Platform through InvestCEO, please note that InvestCEO is the primary provider of your trading relationship.
                ALM Trading operates the Platform and licenses software to InvestCEO but does not manage your trading accounts, funds, or financial relationship with InvestCEO.
                Your contractual relationship is with your Licensor, not ALM Trading.
                ALM Trading does not provide you with a trading account, does not manage your funds, and is not responsible for your trading relationship with Licensor.
            </p>

            <h4>2. Eligibility</h4>
            <p>You must be at least 18 years of age to use the Platform. You are solely responsible for ensuring compliance with applicable laws and regulations in your jurisdiction.</p>

            <div>
                <h4>3. License Grant</h4>
                <p>Subject to your compliance with these Terms, <strong>InvestCEO</strong> grants you a limited, non-exclusive, non-transferable license to use the ALM Trading software platform (the “Platform”) solely for your personal or business trading purposes.</p>


                <p>You acknowledge and agree that:</p>
                <ul>
                    <li>ALM Trading, LLC is the owner and primary licensor of the Platform.</li>
                    <li>InvestCEO has been granted rights by ALM Trading to sub-license the Platform to you.</li>
                    <li>Your license arises exclusively through InvestCEO, and your financial relationship is with InvestCEO, not ALM Trading.</li>
                </ul>
            </div>



            <div>
                <h4>4. Use of the Platform</h4>
                <p>You agree not to:</p>
                <ul>
                    <li>Reverse-engineer, decompile, or attempt to derive the source code of the Platform;</li>
                    <li>Use the Platform for unlawful purposes;</li>
                    <li>Resell, sublicense, or transfer access without prior written consent.</li>
                    <li>Harm the Platform in any way.</li>
                </ul>
            </div>

            <h4>5. No Financial Advice</h4>
            <p>The Platform is provided for software automation only. ALM Trading does not provide investment, legal, or financial advice.
                All trading decisions are made solely by you and at your own risk.</p>

            <h4>6. Disclaimers</h4>
            <p><strong>i. Risk and Acknowledgement: </strong>Trading securities, futures, and derivatives involves substantial risk of loss and is not suitable for every investor.
                Automated trading may increase risk exposure. Past performance is not indicative of future results.
                By using the Platform, you acknowledge and accept these risks.
                You assume all risk when using the Platform. ALM Trading and InvestCEO are not liable for any losses, monetary or otherwise.
                There is no guarantee to prevent losses or to make profits by using the Platform.
                Additionally, the Platform involves the use of electronic transmission of data and information across wireless and other networks. You acknowledge
                and agrees that ALM Trading does not operate or control such networks and is not responsible or liable for the privacy and security of 
                your data or information. You agree that it is solely your responsibility to secure and protect the networks 
                you use. You must also safeguard and protect your login credentials and any other sensitive information. If 
                you choose to have the Platform connect automatically to your brokerage, you acknowledge that it is 
                your decision to store your connection information in the ALM system to allow the Platform to connect automatically, 
                and ALM takes no responsibility for your actions, connections, trade settings, or any settings or configuration in the 
                Platform. You remain fully responsible for any trades, trade settings, turning trading on and off, connections, and 
                similar settings available in the Platform. Additionally, ALM Trading is not responsible in the event of a data breach or hack of the 
                Platform. If such an unforeseen event occurs, you must take the necessary steps to protect your information. 
                You may choose to not connect automatically and, therefore, not store connection information in the Platform if the risk 
                associated with doing so is too great. You bear the full risk and responsibility of the factors described in this 
                agreement if you choose to connect automatically. 
            </p>
            <p><strong>ii. Rules: </strong>
                You are not required to use a prop firm but if one is being utilized, 
                you are responsible for abiding by the prop firm’s rules and regulations. You are responsible for 
                monitoring trades in your brokerage and must edit or cancel trades manually if needed setting appropriate loss limits to protect 
                assets. ALM Trading is not responsible for outages or technical issues of the brokerage or other third party software.
            </p>
            <p><strong>iii. Availability: </strong>
                ALM Trading does not guarantee uptime of the Platform and may perform planned or unplanned maintenance or upgrade 
                activities that impact the availability of the Platform. ALM is providing the Platform “as is” and “as available” 
                without warranties of any kind. 
            </p>


            <h4>7. Fees & Payments</h4>
            <p>Any fees, billing practices, or subscription terms will be communicated at the time of purchase or via InvestCEO if you subscribe through them.
                All payments are subject to the terms of your licensor.</p>

            <h4>8. Data & Privacy</h4>
            <p>Your use of the Platform is also governed by our Privacy Policy.</p>

            <h4>9. Termination & Suspension</h4>
            <p>We may suspend or terminate your access to the Platform at our sole discretion if you violate these Terms or engage in unlawful or abusive behavior.</p>

            <h4>10. Intellectual Property</h4>
            <p>All trademarks, logos, algorithms, and other intellectual property related to the Platform belong exclusively to ALM Trading.
                You are granted no rights other than those expressly stated in these Terms.</p>

            <div>
                <h4>11. Limitation of Liability</h4>
                <p>To the fullest extent permitted by law:</p>
                <ul>
                    <li>Licensor shall not be liable for any trading losses, lost profits, or indirect, incidental, or consequential damages.</li>
                    <li>Total liability shall not exceed the lesser of (i) fees paid to your licensor in the preceding 12 months or (ii) $350.</li>
                    <li>You agree that ALM Trading shall have no liability to you arising out of your use of the Platform. All claims, if any, must be made directly to your Licensor.</li>
                </ul>
            </div>

            <h4>12. Indemnification</h4>
            <p>You agree to indemnify and hold harmless both InvestCEO (as your licensor) and ALM Trading (as the underlying technology provider), including their affiliates, officers, and employees, from any claims, damages, or losses arising from your use of the Platform or violation of these Terms.</p>


            <h4>13. Governing Law & Dispute Resolution</h4>
            <p>
                In case of any dispute arising out of this Agreement, including any question regarding its interpretation, existence, validity, or termination, 
                each party will use its best efforts to resolve the dispute by good faith negotiation within a period of Thirty (30) Business Days following notification
                of the dispute. Good faith negotiation requires that positions and offers be made and the articulated reasons for rejected such positions or 
                offers are provided. Should such good faith negotiations be unable to resolve all disputed issues, the parties will attempt to resolve any 
                remaining dispute arising out of or relating to this by binding arbitration under the rules of the American Arbitration Association. The arbitrator shall award the 
                costs of arbitration, including reasonable attorney fees, to the prevailing party. The arbitrator's award will be final, and judgment may 
                be entered upon it by any court having proper jurisdiction. Arbitration shall be limited to a single (1) arbitrator. Any party who files a 
                lawsuit in court without following the procedures stated herein shall be in breach of this provision of the Agreement and the non-filing party 
                shall be awarded the cost of dismissing such action, including reasonable attorney fees.
                You waive any right to participate in class actions.
            </p>


            <h4>14. Changes to Terms</h4>
            <p>We may update these Terms from time to time. Updated versions will be posted with a new “Last Updated” date.
                Continued use of the Platform constitutes acceptance of the revised Terms.</p>

            <h4>15. Miscellaneous</h4>
            <p>These Terms constitute the entire agreement between you, your licensor, and ALM Trading.
                If any provision is held invalid, the remainder shall remain in effect.
                Our failure to enforce any provision shall not constitute a waiver.</p>

            <h4>16. Contact Us</h4>
            <p>If you have questions about these Terms, contact your Licensor.</p>
        </div>
    )
}

